import React, {useEffect, useState} from 'react';
import 'antd/dist/reset.css';
import './index.css';
import { Layout } from 'antd';
import { Provider } from "react-redux";
import store from "./stateManagement/store";
import {loadUser} from "./stateManagement/actions/auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DashboardPage from './pages/dashboard';
import DealsPage from './pages/deals';
import DealDetailsPage from './pages/dealsDetails';
import TrendsPage from './pages/trends';
import ReportsPage from './pages/reports';
import LoginForm from './pages/login';
import MappingPage from './pages/mapping';
import ResourcesPage from './pages/resources';
import MainWrapper from './components/wrappers/mainWrapper';
import ProtectedRoute from './components/hocs/protectedRoute';
import SideMenu from './components/layout/sideMenu';
import DataAvailabilityPage from './pages/dataAvailability';
import DataUploadPage from './pages/dataUpload';
import CronsPage from './pages/crons';
import UsersPage from './pages/users';
import PrivacyPolicyPage from './pages/privacyPolicy';
import TermsAndConditionsPage from './pages/termsOfServices';
//THD Pages
import ThdDirectPage from './pages/THD/direct';

const { Content } = Layout;

const App = () => {

  const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);

  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      const isNowPortrait = window.matchMedia("(orientation: portrait)").matches;
      setIsPortrait(isNowPortrait);
    };

    // Attach event listeners
    window.addEventListener("resize", handleOrientationChange);
    window.addEventListener("orientationchange", handleOrientationChange);

    // Initial check
    handleOrientationChange();

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleOrientationChange);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);
  
  return (
    <Provider store={store}>
      <Layout className="layout">
        <Router>
          {
            isPortrait ? (
              <h3 id="pmode-intro">Please rotate your phone to landscape mode in order to use the interface. Thank you!</h3>
            ) : (
              <Content>
                <SideMenu/>
                <MainWrapper>
                  <Routes>
                    <Route path='/thd/deals/:dealName' element={<ProtectedRoute><DealDetailsPage/></ProtectedRoute>} />
                    <Route 
                      path='/thd/mapping' 
                      element={<ProtectedRoute requiresAdmin={true}><MappingPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/mapping' 
                      element={<ProtectedRoute requiresAdmin={true}><MappingPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/resources' 
                      element={<ProtectedRoute requiresAdmin={true}><ResourcesPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/thd/deals' 
                      element={<ProtectedRoute><DealsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/thd/direct' 
                      element={<ProtectedRoute><ThdDirectPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/deals' 
                      element={<ProtectedRoute><DealsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/thd/trends' 
                      element={<ProtectedRoute><TrendsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/trends' 
                      element={<ProtectedRoute><TrendsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/thd/reports' 
                      element={<ProtectedRoute><ReportsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/reports' 
                      element={<ProtectedRoute><ReportsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/data-availability' 
                      element={<ProtectedRoute requiresAdmin={true}><DataAvailabilityPage/></ProtectedRoute>} 
                      exact={true}
                    />
                     <Route 
                      path='/data-upload' 
                      element={<ProtectedRoute requiresAdmin={true}><DataUploadPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/crons' 
                      element={<ProtectedRoute requiresAdmin={true}><CronsPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/users' 
                      element={<ProtectedRoute requiresAdmin={true}><UsersPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/login' 
                      element={<LoginForm/>} 
                      exact={true}
                    />
                    <Route 
                      path='/terms-of-service' 
                      element={<TermsAndConditionsPage/>} 
                      exact={true}
                    />
                    <Route 
                      path='/privacy-policy' 
                      element={<PrivacyPolicyPage/>} 
                      exact={true}
                    />
                    <Route 
                      path='/thd' 
                      element={<ProtectedRoute><DashboardPage/></ProtectedRoute>} 
                      exact={true}
                    />
                    <Route 
                      path='/' 
                      element={<ProtectedRoute><DashboardPage/></ProtectedRoute>} 
                      exact={true}
                    />
                  </Routes>
                </MainWrapper>
              </Content>
            )
          }
        </Router>
      </Layout>
    </Provider>
  )
};

export default App;